import React from 'react';
import { Link as RouteLink } from 'react-router-dom';
import { Button,Menu, MenuItem, Toolbar, Typography } from '@material-ui/core';
import { ExpandMore, Language } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { Region } from '../../utils/i18n/region';
import i18n from '../../i18n';
import cloverLogo from '../../assets/clover-logo.png';
import { ButtonVariant, CoreButton } from '@clover/web-lib-core/dist/components';
import { Locale } from '../../utils/i18n/locale';

export const CloverHeader = (): JSX.Element => {
  const [t] = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<Element | null>(null);

  const handleMenu = (event: React.MouseEvent) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => setAnchorEl(null);

  const onSelectLocale = (locale: Locale) => {
    location.href = Region.getRedirectUrl(locale);
    handleCloseMenu();
  };
  
  const returnToCloverHomePage = window.origin;

  return (
      <div>
        <Toolbar className={`${styles.bar} ${styles.maxWidthWrapper}`}>
          <a className={styles.homeButton} type="button" href={returnToCloverHomePage}>
            <img src={cloverLogo} alt={t('Clover')} />
          </a>
          <div className={styles.buttonsWrapper}>
            <Button
              aria-label="language"
              aria-controls="locale-menu"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
              className={styles.languageButton}
            >
              <Language color="inherit" />
              <Typography variant="body1" component="span">
                {t('language')}
              </Typography>
              <ExpandMore color="inherit" fontSize="small" />
            </Button>
            <Menu
              id="locale-menu"
              getContentAnchorEl={null} // required in order to override anchorOrigin
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              open={!!anchorEl}
              onClose={handleCloseMenu}
            >
              {Region.getLocales().map(locale => (
                <MenuItem
                  key={locale.languageTag}
                  onClick={() => onSelectLocale(locale)}
                  selected={locale.languageTag === i18n.language}
                >
                  {locale.toString()}
                </MenuItem>
              ))}
            </Menu>
            <RouteLink to='/dashboard/login' color="inherit">
              <CoreButton variant={ButtonVariant.PRIMARY}>{t('log_in')}</CoreButton>
            </RouteLink>
          </div>
        </Toolbar>
      </div>
  );
};
